exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#addQuestionButton[data-v-116a4981] {\n  margin-bottom: 30px;\n}\n.question_drag_icon[data-v-116a4981]:hover {\n  cursor: grab;\n}\n", ""]);

// exports
